import { render, staticRenderFns } from "./DocumentRestoreContainer.vue?vue&type=template&id=0600df9e"
import script from "./DocumentRestoreContainer.vue?vue&type=script&lang=js"
export * from "./DocumentRestoreContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports